import React from 'react';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import AgentConfirmationCard from './AgentConfirmationCard';

interface DeepResearchConfirmationData {
  type: 'deep_research_confirmation';
  justificativa?: string;
  // true só no card empurrado AO VIVO (via SSE); o card PERSISTIDO (reidratado do
  // histórico no reload) vem sem `active` → renderiza passivo, sem botões, pra não
  // re-rodar a pesquisa (demorada e com cota semanal) num clique acidental.
  active?: boolean;
}

interface Props {
  data: DeepResearchConfirmationData;
}

/**
 * Card de confirmação da Pesquisa Aprofundada (gate humano antes da pesquisa
 * longa/multi-fonte proposta pelo modelo via propor_deep_research).
 * Ao vivo (active): botões disparam o evento de janela `deepResearchDecision`.
 * Histórico (sem active): só o registro da proposta, sem botões.
 */
const DeepResearchConfirmation: React.FC<Props> = ({ data }) => (
  <AgentConfirmationCard
    icon={<TravelExploreIcon style={{ fontSize: 17 }} />}
    title="Rodar a Pesquisa Aprofundada?"
    description={
      'Pesquisa longa em muitas fontes da web, com síntese estruturada e citações. ' +
      'Entrega uma resposta bem mais completa, mas leva alguns minutos e usa a sua ' +
      'cota semanal de pesquisas aprofundadas.'
    }
    justificativa={data.justificativa}
    active={data.active}
    runLabel="Pesquisar"
    declineLabel="Agora não"
    decidedRunText="▶ Rodando a Pesquisa Aprofundada…"
    decidedDeclineText="✕ Seguindo sem a pesquisa aprofundada, com respostas diretas."
    passiveText="— proposta de pesquisa aprofundada registrada no histórico —"
    onDecide={(decision) =>
      window.dispatchEvent(new CustomEvent('deepResearchDecision', { detail: { decision } }))
    }
    cardTestId="deep-research-confirmation"
    runTestId="dr-run"
    declineTestId="dr-decline"
  />
);

export default DeepResearchConfirmation;
